import React from 'react'

import './PricingListTableHeaders.scss'

// Due to sticky headers, this must be placed within a th element.
export const PricingListTableHeaders = ( { headerHeight }) => {
    return (
        <thead
            // style={{ height: headerHeight }}
            id={'PricingListTableHeaders'}
        >
            <tr>
                <th>
                    <div className={'header-div'}>
                        {/* Empty for leading year column */}
                    </div>
                </th>
                <th>
                    <div className={'header-div'}>
                        Model
                    </div>
                </th>
                <th>
                    <div className={'header-div'}>
                        Trim
                    </div>
                </th>
                <th>
                    <div className={'header-div'}>
                        Note
                    </div>
                </th>
                <th>
                    <div className={'header-div'}>
                        MSRP
                    </div>
                </th>
                <th>
                    <div className={'header-div'}>
                        Invoice
                    </div>
                </th>
                <th>
                    <div className={'header-div'}>
                        Price Adjust
                    </div>
                </th>
                <th>
                    <div className={'header-div'}>
                        Actions
                    </div>
                </th>
            </tr>
        </thead>
    )
}